import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GetServiciosWebService } from '../shared/services/web/get-servicios-web.service';

@Injectable({
	providedIn: 'root'
})
export class serviciosGuard implements CanActivate {
	constructor(private _serivicioApiResource: GetServiciosWebService, private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		const slug = route.paramMap.get('slug');

		if (!slug) {
			this.router.navigate(['/error']);
			return of(false);
		}

		return this._serivicioApiResource.getservicio(slug).pipe(
			map((data) => {
				if (data) {
					// Almacena la información en la propiedad 'data' de la ruta
					route.data = { ...route.data, pageData: data };
					return true;
				}
				this.router.navigate(['/page-not-found']);
				return false;
			}),
			catchError(() => {
				this.router.navigate(['/page-not-found']);
				return of(false);
			})
		);
	}
}
